export const ASYNC_JOB_COUNTRY_US = 'US';

export const ASYNC_JOB_REQUEST_ID_KEY = 'requestId';
export const ASYNC_JOB_REQUESTID_KEY = 'requestid';

export const ASYNC_JOB_HINTS = {
  processing: 'Please wait until this job completes. Do not refresh or close this window.',
  success: 'Job completed successfully.',
  complete: 'Job completed successfully.',
  error: 'This job could not be completed. Review the message below.',
  empty: 'Starting job...',
};

export const ASYNC_JOB = {
  INITIALIZE: {
    title: 'Initializing Entry Summary',
    timeoutErrorMessage: 'Initialize entry summary request timed out.',
    errorFallbackMessage: 'Failed to initialize entry summary form.',
    requestIdKey: ASYNC_JOB_REQUEST_ID_KEY,
  },
  SUBMIT: {
    title: 'Submitting Entry Summary',
    timeoutErrorMessage: 'Submit entry summary request timed out.',
    errorFallbackMessage: 'Failed to submit entry summary form.',
    requestIdKey: ASYNC_JOB_REQUESTID_KEY,
  },
  GENERATE_PDF_ES: {
    title: 'Generating 7501-Entry Summary PDF',
    timeoutErrorMessage: 'Generate 7501-Entry Summary PDF request timed out.',
    errorFallbackMessage: 'Failed to generate 7501-Entry Summary PDF.',
    requestIdKey: ASYNC_JOB_REQUEST_ID_KEY,
  },
  GENERATE_PDF_CR: {
    title: 'Generating 3461-Cargo Release PDF',
    timeoutErrorMessage: 'Generate 3461-Cargo Release PDF request timed out.',
    errorFallbackMessage: 'Failed to generate 3461-Cargo Release PDF.',
    requestIdKey: ASYNC_JOB_REQUEST_ID_KEY,
  },
  FILE: {
    title: 'Filing Entry Summary',
    timeoutErrorMessage: 'File entry summary request timed out.',
    errorFallbackMessage: 'Failed to file entry summary form.',
    requestIdKey: ASYNC_JOB_REQUESTID_KEY,
  },
};

export const isUsShipment = () =>
  (window.shipmentCountry || ASYNC_JOB_COUNTRY_US) === ASYNC_JOB_COUNTRY_US;

export const buildAsyncSocketFields = (job, requestId, userId) => ({
  [job.requestIdKey]: requestId,
  userId: userId || '',
  asyncExecution: true,
});
